import CompilationsApi from '@/frontend/api/compilations';
import UserWorksApi from '@/frontend/api/userWorks';
import handlerErrorRequest from '@/frontend/functions/handlerErrorRequest';
import { ElMessage, ElLoading } from 'element-plus';
import { mapGetters } from 'vuex';
import { EditPen, Link } from '@element-plus/icons-vue';
export default {
  name: "ProfileCompilationPage",

  data() {
    return {
      Compilation: {},
      pathToCompilation: '',
      userWorks: []
    };
  },

  components: {
    EditPen,
    Link
  },
  computed: mapGetters(['user']),
  methods: {
    handlerCopy(link) {
      try {
        navigator.clipboard.writeText(link).then(() => ElMessage({
          message: 'Ссылка скопирована',
          type: 'success'
        }));
      } catch (e) {
        ElMessage({
          message: 'Ошибка при копировании. Проверьте наличие протокола https',
          type: 'error'
        });
      }
    }

  },

  beforeMount() {
    let loader = ElLoading.service({
      lock: false,
      text: 'Загрузка'
    });
    CompilationsApi.get({
      expand: ['works', 'works.author'].join(',')
    }, this.$route.params.id).then(response => {
      this.Compilation = response;
      this.Compilation.accessLink = this.pathToCompilation.replace(':id', this.Compilation.access_link);
      UserWorksApi.get({
        'filter[compilationId]': this.Compilation.id,
        'per-page': 100000,
        'expand': ['compilation'].join(',')
      }).then(response => this.userWorks = response.items).catch(handlerErrorRequest);
    }).catch(handlerErrorRequest).finally(() => loader.close());
  },

  created() {
    this.$router.getRoutes().some(item => {
      if (item.name !== 'compilation') return false;
      this.pathToCompilation = window.location.origin + item.path;
      return true;
    });
  }

};